import type { StoneSpecification } from '../domain/models/ProductDetail';
import { normalizeNumericField } from './normalizeNumericField';

export function readOptionalString(value: unknown): string | null {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  return trimmed || null;
}

export function normalizeStoneSpecifications(value: unknown): StoneSpecification[] {
  if (!Array.isArray(value)) return [];

  return value.reduce<StoneSpecification[]>((specs, item) => {
    if (!item || typeof item !== 'object') return specs;

    const raw = item as Record<string, unknown>;
    const stoneType = readOptionalString(raw.stoneType);
    if (!stoneType) return specs;

    specs.push({
      count: normalizeNumericField(raw.count as number | string | null | undefined),
      shape: readOptionalString(raw.shape),
      totalWeight: normalizeNumericField(
        raw.totalWeight as number | string | null | undefined
      ),
      size: readOptionalString(raw.size),
      settingType: readOptionalString(raw.settingType),
      stoneType,
    });
    return specs;
  }, []);
}
